import { Badge as AntBadge, BadgeProps } from "antd";
import { RibbonProps } from "antd/es/badge/Ribbon";
import useTheme from "../hooks/theme";

type BadgeColor = BadgeProps["color"] | "accent";

const Badge = ({
  color,
  styles,
  style,
  ...props
}: Omit<BadgeProps, "color"> & { color?: BadgeColor }) => {
  const theme = useTheme();
  const accent = color === "accent";
  const resolvedColor = accent ? theme.colors.accent : color;
  const accentText = accent ? { color: theme.colors.onAccent } : undefined;
  return (
    <AntBadge
      {...props}
      color={resolvedColor}
      style={{ ...accentText, ...style }}
      styles={{
        ...styles,
        indicator: {
          boxShadow: "none",
          fontWeight: 600,
          ...accentText,
          ...styles?.indicator,
        },
      }}
    />
  );
};

const Ribbon = ({
  ...props
}: RibbonProps & { type: "success" | "critical" }) => {
  const theme = useTheme();
  return (
    <AntBadge.Ribbon
      {...props}
      color={
        props.type === "critical"
          ? theme.colors.destructive
          : theme.colors.success
      }
    />
  );
};

Badge.Ribbon = Ribbon;

export default Badge;
